import { useT } from '@hooks';
import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	text?: string;
}

const StyledButton = styled.button`
	background: none;
	border: none;
	width: 100%;
	height: 21px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 18px;
	line-height: 21px;
	color: #6a48bd;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
`;

export const SkipButton: FC<Props> = props => {
	const { T } = useT();
	const { onClick, text = T('payment_error_skip') } = props;
	return <StyledButton onClick={onClick}>{text}</StyledButton>;
};
